import React from 'react';
type Tome = {
  number: string;
  title: string;
  tag: string;
  framework: string;
  promise: string;
  band: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '1',
  title: 'Beginner Lessons',
  tag: 'Juniors & adults',
  framework: 'The Any-Wind Lesson System · The Wind Check · The Clock Face Method',
  promise: 'From the welcome brief on the dock to a first solo loop.',
  band: 'bg-peach',
  badge: 'bg-peach-soft text-peach-deep',
  contents: ['A welcome brief: rules, buddy pairs and life jacket fit in 15 minutes', 'Launch and land with a routine every sailor follows', 'Teach points of sail with the wind at 12 o’clock', 'Tack on the grass first, then afloat on a short beat', 'Controlled capsize practice in a supervised area', 'Five lessons for a brand-new group tomorrow morning']
}, {
  number: '2',
  title: 'Boat Handling',
  tag: 'Intermediate',
  framework: 'The Feel-Fix-Repeat Loop · The Stop-Hold-Go Box',
  promise: 'When sailors stop surviving and start sailing.',
  band: 'bg-teal',
  badge: 'bg-teal-soft text-teal-deep',
  contents: ['Trim by the telltales and keep the boat flat through gusts', 'Gybe on the grass, then afloat, on a count', 'Stop, hold and sail backwards inside a marked box', 'Docking in onshore, offshore and cross breezes', 'Crew overboard recovery from any point of sail', '15 intermediate problems on the water and the fix for each']
}, {
  number: '3',
  title: 'Shore & Theory',
  tag: 'Every no-sail day',
  framework: 'The Show-Touch-Try Shore Method · The 15-Minute Shore Rule',
  promise: 'Shore time they remember, and a plan for every day you can’t sail.',
  band: 'bg-sage',
  badge: 'bg-sage-soft text-sage-deep',
  contents: ['A sea-breeze demo with a fan and a tray', 'Port and starboard walked out on the grass', 'Six core knots tied by feel, plus a knot relay', 'Read a marine forecast as a group', 'Full no-sail days: magnetic-board tactics, a sail lab, a quiz show', '25 five-minute fillers for wind holds and rain breaks']
}, {
  number: '4',
  title: 'Race Training',
  tag: 'Coach-ready drills',
  framework: 'The Race Drill Builder · The Coach Boat Lane',
  promise: 'From the first start to the first regatta.',
  band: 'bg-rose',
  badge: 'bg-rose-soft text-rose-deep',
  contents: ['Time on distance, line sights and an acceleration gate', 'Rabbit starts and ten rapid starts back to back', 'Shift hunts, clear-air lanes and tacks on the whistle', 'Windward and leeward mark rounding drills', 'Mark-room role-play on the grass and a mock protest', 'A full practice regatta run by the group']
}, {
  number: '5',
  title: 'Junior Programs & Camp Days',
  tag: 'Ages 6–17',
  framework: 'The Age-Fit Game Grid · The Camp Day Rhythm',
  promise: 'Plan the camp week before the weather plans it for you.',
  band: 'bg-lav',
  badge: 'bg-lav-soft text-lav-deep',
  contents: ['Game length, rules and pressure set for ages 6–8, 9–12 and 13–17', 'Treasure hunts, boat tag and capture the flag on the water', 'Teens skipper part of the lesson and coach younger sailors', 'Five-day beginner and intermediate camps, with a swap for every block', 'A headcount game that makes the regroup signal automatic', 'Running 30 kids with few boats and several instructors']
}, {
  number: '6',
  title: 'Courses & Seasons',
  tag: 'Adults & full seasons',
  framework: 'The Season Arc · The Skill Sign-Off',
  promise: 'Adult courses, certification prep and the whole season on one page.',
  band: 'bg-sky',
  badge: 'bg-sky-soft text-sky-deep',
  contents: ['Weekend and five-evening adult courses, every swap included', 'Keelboat crew roles, winch work and docking', 'Mock assessments and a retake day for certification prep', 'Eight-week season templates: beginner, intermediate and race team', 'The morning weather call: who decides and how to tell everyone', 'How to rescue a season after two weeks lost to the weather']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="paper-grain w-full bg-paper" data-id="element-262" data-mp="3h5dzcyrh2xmi">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-263" data-mp="3ux26enmv6vwm">
        <div className="text-center" data-id="element-264" data-mp="3pzirrmm98h45">
          <p className="text-sm font-semibold text-teal-deep" data-id="element-265" data-mp="3pyh9oy6tmucx">The complete pack</p>
          <h2 id="tomes-heading" className="mt-3 font-display text-3xl text-navy sm:text-5xl" data-id="element-266" data-mp="8q3yftzbjygb">
            Six volumes. <span className="wash-text" data-id="element-267" data-mp="3tdl3eewfgyl">A whole season, planned.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-navy-soft" data-id="element-268" data-mp="2ahqkri89n56g">
            Volumes 1, 2 and 4 are the skills ladder. Volume 3 is the
            knowledge behind it and your plan for no-sail days. Volumes 5 and
            6 turn it all into camp weeks, adult courses and full seasons. Each
            volume is about 50 landscape pages and works on its own.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-269" data-mp="bcczf5ni6ib3">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-card" data-id="element-270" data-mp="g9mr6ryd7623">
              <span className={`h-2 w-full ${tome.band}`} data-id="element-271" data-mp="29bxzi9l1fdr" />
              <div className="flex flex-1 flex-col p-6" data-id="element-272" data-mp="6d06q49yah0l">
                <div className="flex items-center gap-2.5" data-id="element-273" data-mp="6adys3j5dzhu">
                  <span className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-base ${tome.badge}`} data-id="element-274" data-mp="3oj51ayhoji29">
                    {tome.number}
                  </span>
                  <span className="text-xs font-semibold text-navy-muted" data-id="element-275" data-mp="1mqgvchdnigis">
                    Volume {tome.number} · {tome.tag}
                  </span>
                </div>
                <h3 className="mt-3 font-display text-2xl leading-snug text-navy" data-id="element-276" data-mp="1q8ecryft9hwh">{tome.title}</h3>
                <p className="mt-1 text-xs font-bold text-teal-deep" data-id="element-277" data-mp="1l9uohrdqvu0y">{tome.framework}</p>
                <p className="mt-2 text-sm text-navy-soft" data-id="element-278" data-mp="1gai2t9ym0szy">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-paper-dark pt-4" data-id="element-279" data-mp="1gckppl4gu60g">
                  {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-navy" data-id="element-280" data-mp="28yw0folsdnaz">
                      <span className={`mt-[7px] h-1.5 w-1.5 flex-none rounded-full ${tome.band}`} data-id="element-281" data-mp="29106ac38wwdw" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}